<template>
  <div class="bg-neutral/60 p-2 flex flex-col gap-2 rounded-lg shadow">
    <div class="flex gap-2">
      <div
        class="w-14 shrink-0 rounded overflow-hidden pointer-events-none aspect-[3/4] skeleton-loading-bg"
      />
      <div class="flex flex-col gap-2 flex-grow justify-between">
        <span
          class="text-xs font-semibold rounded w-full skeleton-loading-bg h-4"
        />
        <div class="flex flex-col gap-1">
          <span
            v-for="i in 3"
            :key="i"
            :class="{
              'w-[50%]': i === 3,
              'w-full': i !== 3,
            }"
            class="text-xs line-clamp-3 rounded skeleton-loading-bg h-3"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <span
        v-for="i in 3"
        :key="i"
        :class="{
          'w-[50%]': i === 3,
          'w-full': i !== 3,
        }"
        class="text-xs line-clamp-3 rounded skeleton-loading-bg h-3"
      />
    </div>
  </div>
</template>
